import { render, staticRenderFns } from "./ItemDataTable.vue?vue&type=template&id=381b3295"
import script from "./ItemDataTable.vue?vue&type=script&lang=js"
export * from "./ItemDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports